import { render, staticRenderFns } from "./FXRate.vue?vue&type=template&id=4e8b092b&scoped=true"
import script from "./FXRate.vue?vue&type=script&lang=js"
export * from "./FXRate.vue?vue&type=script&lang=js"
import style0 from "./FXRate.vue?vue&type=style&index=0&id=4e8b092b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8b092b",
  null
  
)

export default component.exports